"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var _ = require("../../../");

var _FileStack = _interopRequireDefault(require("../../../FileStack"));

var _helper = require("../common/helper");

var _consts = require("../consts");

var _styles = require("./styles");

/* eslint-disable indent */
function PollOptionImage(props) {
  var poll = props.poll,
      dispatch = props.dispatch,
      option = props.option,
      optionId = props.optionId;
  var status = poll.status,
      pollId = poll.pollId;
  var imageUrl = option.imageUrl;
  var totalResponses = (0, _helper.getTotalResponses)(poll);

  var onImageClick = function onImageClick(type, url) {
    dispatch({
      type: type,
      payload: {
        pollId: pollId,
        optionId: optionId,
        imageUrl: url
      }
    });
  };

  if (status === _consts.PollStatus.DRAFT) {
    if (!imageUrl) {
      return _react.default.createElement(_FileStack.default, {
        onFileUploadFinished: function onFileUploadFinished(file) {
          return onImageClick(_consts.PollTeacherActions.OPTION_IMAGE_CHANGE, file.url);
        },
        onFileUploadFailed: function onFileUploadFailed(error) {
          return console.log(error);
        },
        tabIndex: -1
      }, _react.default.createElement("span", {
        role: "button",
        tabIndex: -1,
        className: _styles.imageIcon
      }, _react.default.createElement(_.Icon, {
        type: "picture",
        style: {
          fill: _themeConfig.default.color.dark.silver,
          outline: 'none'
        }
      })));
    }

    return _react.default.createElement("div", {
      className: (0, _styles.optionImageContainer)(72)
    }, _react.default.createElement("img", {
      src: imageUrl,
      alt: option.text,
      className: _styles.optionImage
    }), _react.default.createElement("div", {
      className: "imageOverlay"
    }, _react.default.createElement("div", {
      className: "imageOptions"
    }, _react.default.createElement(_FileStack.default, {
      onFileUploadFinished: function onFileUploadFinished(file) {
        return onImageClick(_consts.PollTeacherActions.OPTION_IMAGE_CHANGE, file.url);
      },
      onFileUploadFailed: function onFileUploadFailed(error) {
        return console.log(error);
      }
    }, _react.default.createElement("span", {
      role: "button",
      tabIndex: 0,
      className: "imageOverlayOption"
    }, _react.default.createElement(_.Icon, {
      type: "editNew",
      style: {
        fill: _themeConfig.default.color.dark.silver,
        outline: 'none'
      }
    }))), _react.default.createElement("span", {
      onClick: function onClick() {
        return onImageClick(_consts.PollTeacherActions.OPTION_IMAGE_REMOVE, '');
      },
      role: "button",
      tabIndex: 0,
      className: "imageOverlayOption"
    }, _react.default.createElement(_.Icon, {
      type: "deleteNew",
      style: {
        fill: _themeConfig.default.color.dark.silver,
        outline: 'none'
      }
    })))));
  } else if (status === _consts.PollStatus.LIVE || status === _consts.PollStatus.COMPLETE) {
    if (!imageUrl) {
      return null;
    }

    return _react.default.createElement("div", {
      className: (0, _styles.imageContainer)(totalResponses > 0 ? 36 : 72)
    }, _react.default.createElement("img", {
      src: imageUrl,
      alt: option.text,
      className: _styles.optionImage
    }), ' ');
  }
}

var _default = PollOptionImage;
exports.default = _default;